module.exports = __webpack_public_path__ + "static/media/delete.90310e28.svg";